import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getManagementCountract = createAsyncThunk(
    '/dashboardkontrak/content',
    async ({ page, search, type, limit }) => {
        const userId = localStorage.getItem("userId");

        const response = await axios.get(
            `${process.env.REACT_APP_API_ENDPOINT}/listCountract/${userId}`,
            {
                params: {
                    page: page,
                    search: search,
                    type: type,
                    limit: limit
                }
            }
        );

        return response.data;
    }
);

export const dashboardCountractSlice = createSlice({
    name: 'dashboardkontrak',
    initialState: {
        isLoading: false,
        dashboardkontrak: []
    },

    /*extraReducers: {
        [getManagementCountract.pending]: state => {
            state.isLoading = true
        },
        [getManagementCountract.fulfilled]: (state, action) => {
            state.dashboardkontrak = action.payload.data
            state.isLoading = false
        },
        [getManagementCountract.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getManagementCountract.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getManagementCountract.fulfilled, (state, action) => {
                state.dashboardkontrak = action.payload;
                state.isLoading = false;
            })
            .addCase(getManagementCountract.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export default dashboardCountractSlice.reducer